module.exports = __webpack_public_path__ + "../resources/img/disconnected_icon.595f5dc7.svg";